import React, { useEffect, useState } from "react";
import * as queries from "../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
// APIモジュール
import {
  Button,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Link,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Container,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "../modules/modules";
import { makeStyles } from "@material-ui/core/styles";
import HelpButton from "./HelpButton";

const useStyles = makeStyles((theme) => ({
  field: {
    width: "100%",
    marginTop: theme.spacing(3),
    alignItems: "center",
  },
  interval: {
    marginTop: theme.spacing(5),
  },
  table: {
    width: "100%",
    maxHeight: 300,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    display: "flex",
  },
}));

export default function SearchData(props) {
  const userInfo = props.userInfo;
  const classes = useStyles();
  const [exhibition, setExhibition] = useState([]);
  const [userBuymas, setUserBuymas] = useState([]);
  const [kaiinId, setKaiinId] = useState();

  useEffect(() => {
    if (userInfo.buyma) {
      setUserBuymas(userInfo.buyma.items);
    }
  }, [userInfo]);

  const handleSearchExhibition = function () {
    console.log(kaiinId);
    listExhibitionsBySpecificKaiinId(kaiinId).then((res) => {
      console.log(res);
      setExhibition(res);
    });
  };

  const listExhibitionsBySpecificKaiinId = (kaiinId) => {
    return new Promise(function (resolve, reject) {
      API.graphql(
        graphqlOperation(queries.listExhibitionsBySpecificKaiinId, {
          kaiinId: kaiinId,
          sortDirection: "DESC",
          limit: 100,
        })
      )
        .then((res) => {
          resolve(res.data.listExhibitionsBySpecificKaiinId.items);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return (
    <React.Fragment>
      {userBuymas.length !== 0 ? (
        <Container className={classes.interval}>
          <Typography variant="h4" align="center">
            <HelpButton
              title={
                <>
                  <Typography variant="caption" display="block">
                    登録しているBUYMAアカウントを選択して、出品している情報を取得できます。
                    <br />
                    最新順で100件のみ取得されます。
                  </Typography>
                  <Button
                    variant="contained"
                    target="_blank"
                    fullWidth
                    href="#"
                  >
                    詳しくはこちら
                  </Button>
                </>
              }
            />
            出品リスト
          </Typography>

          <FormControl className={classes.formControl}>
            <InputLabel id="kaiinId">BUYMAアカウント</InputLabel>
            <Select
              id="kaiinId"
              value={kaiinId}
              onChange={(e) => setKaiinId(e.target.value)}
            >
              {userBuymas.map((e) => (
                <MenuItem value={e.kaiinId} key={e.kaiinId}>
                  {e.buyma}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            variant="outlined"
            onClick={handleSearchExhibition}
            className={classes.field}
          >
            検索
          </Button>

          <TableContainer className={classes.table}>
            <Table stickyHeader>
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell align="left">商品ID</StyledTableCell>
                  <StyledTableCell align="left">会員ID</StyledTableCell>
                  <StyledTableCell align="left">出品</StyledTableCell>
                  <StyledTableCell align="left">変更</StyledTableCell>
                  <StyledTableCell align="left">URL</StyledTableCell>
                  <StyledTableCell align="left">BUYMAリンク</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {exhibition.map((row) => {
                  return (
                    <StyledTableRow key={row.id}>
                      <StyledTableCell>{row.id}</StyledTableCell>
                      <StyledTableCell>{row.kaiinId}</StyledTableCell>
                      <StyledTableCell>
                        {row.syuppin ? "出品中" : "停止中"}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.change ? "あり" : "なし"}
                      </StyledTableCell>
                      <StyledTableCell>
                        <Link color="textSecondary" href={row.url}>
                          {row.url}
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Link
                          color="textSecondary"
                          href={"https://www.buyma.com/item/" + row.id}
                        >
                          {"https://www.buyma.com/item/" + row.id}
                        </Link>
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      ) : null}
    </React.Fragment>
  );
}
